// extracted by mini-css-extract-plugin
export var border = "_x-8";
export var brand = "_x-t";
export var button = "_x-l";
export var center = "_x-a";
export var centered = "_x-6";
export var closeButton = "_x-c";
export var disabledWrapper = "_x-m";
export var error = "_x-p";
export var extraLarge = "_x-4";
export var extraSmall = "_x-1";
export var fill = "_x-i";
export var footer = "_x-h";
export var footerAction = "_x-j";
export var footerButtons = "_x-k";
export var header = "_x-7";
export var headerWithClose = "_x-d";
export var icon = "_x-o";
export var info = "_x-s";
export var inline = "_x-9";
export var large = "_x-3";
export var main = "_x-e";
export var modal = "_x-0";
export var nearFull = "_x-5";
export var neutral = "_x-u";
export var noPadding = "_x-g";
export var none = "_x-v";
export var scrollable = "_x-f";
export var small = "_x-2";
export var success = "_x-r";
export var tight = "_x-n";
export var titleIcon = "_x-b";
export var warn = "_x-q";